import { IGameStatItem } from '@api/types/general';
import { TJackpotRoom } from '@api/types/jackpot';
import { CommonColors } from '@api/types/ui';
import { JACKPOT_PLAYER_COLORS } from '@consts/jackpot';
import { isNumeric } from './utils';

interface IChanceToWinParams {
    total_stake: number;
    bank: number;
}

export function calcWinRatio({
    games_won,
    games_lose,
}: {
    games_won: number;
    games_lose: number;
}): number {
    return (
        Number(((games_won / (games_won + games_lose)) * 100).toFixed(0)) || 0
    );
}

const numberThousandFormatter = (value: number) =>
    Math.abs(value) > 999
        ? Math.sign(value) * (Math.abs(value) / 1000) + 'K'
        : Math.sign(value) * Math.abs(value);

export const formatGameStatValue = ({
    type = 'number',
    value,
}: IGameStatItem) => {
    if (type === 'number') return numberThousandFormatter(value);
    if (type === 'percentage') return `${value}%`;
    if (type === 'plus-preffixed') return `+${value}`;
};

export const handleCommonColorsValue = (playerNumber: number): CommonColors => {
    if (playerNumber % 2) return 'lyla';
    if (playerNumber % 3) return 'blue';
    return 'yellow';
};

export const calcChanceToWin = ({
    bank,
    total_stake,
}: IChanceToWinParams): number =>
    Number(((total_stake / bank) * 100).toFixed(1));

export function getRoomIndex(room: TJackpotRoom) {
    switch (room) {
        case 'high_room':
            return 0;
        case 'low_room':
            return 1;
    }
}

const alphabet = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
];

export const generateRandomColors: () => number[] = () => {
    const randomColors: number[] = [];
    while (randomColors.length < 4) {
        var r = Math.floor(Math.random() * 4) + 1;
        if (!randomColors.includes(r)) randomColors.push(r);
    }
    return randomColors;
};

export function generateRandomColorsFromUid(uid: string): number[] {
    const randomIndexes: number[] = [];

    for (let i = 0; i < uid.length; i++) {
        const c = uid[i];
        let letterIndex = isNumeric(c) ? parseInt(c) : alphabet.indexOf(c);

        if (letterIndex > JACKPOT_PLAYER_COLORS.length - 1) {
            letterIndex = JACKPOT_PLAYER_COLORS.length - 1;
            while (randomIndexes.includes(letterIndex)) {
                letterIndex--;
            }
        } else {
            while (randomIndexes.includes(letterIndex)) {
                letterIndex++;
            }
        }

        randomIndexes.push(letterIndex);
    }

    for (let h = 0; h < JACKPOT_PLAYER_COLORS.length; h++) {
        if (!randomIndexes.includes(h)) {
            randomIndexes.push(h);
        }
    }
    if (uid === '689b9') {
        console.log('FINAL ARRAY');
        console.log(randomIndexes);
    }
    return randomIndexes;
}
